import Icon from '@uikit/components/Icon/Icon';
import Picture from '@uikit/components/Picture/Picture';
import SignetLink from '../parts/SignetLink/SignetLink';
import SignetOverviewPageLink from '../parts/SignetOverviewPageLink/SignetOverviewPageLink';
import styles from './SignetList.module.scss';
import type { SignetListProps } from './types';

const SignetList = ({ signets, overviewPagePath }: SignetListProps) => {
  return (
    <div className={styles.base}>
      <div className={styles.list}>
        {signets.map(({ image, anchorId }) => (
          <SignetLink
            key={anchorId}
            anchorId={anchorId}
            overviewPagePath={overviewPagePath}
            className={styles.item}
          >
            <Picture asset={image} className={styles.image} />
          </SignetLink>
        ))}
      </div>

      <div className={styles.linkWrapper}>
        <SignetOverviewPageLink path={overviewPagePath} className={styles.link}>
          <span className={styles.linkInner}>
            <Icon variant="action/arrow-right" size="iconSize24" />
            Mehr über unsere Auszeichnungen erfahren
          </span>
        </SignetOverviewPageLink>
      </div>
    </div>
  );
};

export default SignetList;
